<template>
  <div class="flex">
    <div class="bg-white rounded-md shadow border-1 w-full">
      <div class=" -mt-3 p-8">
        <h3 class="text-xl font-medium leading-6 text-gray-900 block pb-3 w-full">{{this.isTypeBenevole ? $t('treatments.additional-info') : $t('treatments.todo')}}</h3>
        <div class="leading-relaxed" style="max-height: 220px; overflow: auto" v-if="treatment.note" v-html="treatment.note"></div>
        <div v-else class="italic text-sm text-gray-400">{{$t('global.not_set')}}</div>
        <Link  v-if="!viaVolunteer" class="btn-indigo inline-flex items-center mt-2 mb-3 lg:mb-0 max-w-md" :href="`/applicants/${treatment.applicant_id}/treatments/${treatment.id}/edit-note/`">
          <span>{{$t('global.update')}}</span>
        </Link>
      </div>
    </div>
  </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
import '@vueup/vue-quill/dist/vue-quill.core.css'
export default{
  props:{
    treatment: Object,
    viaVolunteer: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isTypeBenevole(){
      return (this.treatment.treatment_type_id === 6)
    },
  },
  components:{Link}
}
</script>
